<template>
  <div class="flightInfo">
    <AirportList
      :locale="locale"
      :lang="lang"
      :list="airport" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AirportList from '@/components/FlightInfo/AirportList.vue'

export default {
  name: 'FlightInfo',
  props: [
    'locale',
    'lang'
  ],
  components: {
    AirportList
  },
  computed: {
    ...mapGetters({
      airport: 'flightinfo/getAirport'
    })
  },
  watch: {
    '$route' (to, from, next) {
      this.track()
    }
  },
  created () {
    this.$store.commit('loading', true)
    this.$store.dispatch('flightinfo/getAirport').then((res) => {
      if (!res.use) {
        alert(this.locale.invalid_service)
        this.$router.replace({ name: 'main' })
      } else {
        this.track()
      }
      this.$store.commit('loading', false)
    })
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'flight information'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
